import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Submissions from "@/pages/admin/Submissions";
import ContentPage from "@/pages/admin/ContentPage";
import MediaPage from "@/pages/admin/MediaPage";
import SettingsPage from "@/pages/admin/SettingsPage";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="fixed inset-0 bg-[#0A0A0A] flex items-center justify-center text-[#525252]">Yükleniyor...</div>;
  if (user === false) return <Navigate to="/admin/giris" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/giris" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="basvurular" element={<Submissions />} />
              <Route path="icerik" element={<ContentPage />} />
              <Route path="medya" element={<MediaPage />} />
              <Route path="ayarlar" element={<SettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#141414", border: "1px solid #262626", color: "#EDEDEA", borderRadius: 0 } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
